module.exports = __webpack_public_path__ + "img/Macbook Pro Tilted Screen Mockup.35eeecd8.png";